import { useMemo } from 'react';
import TagInputPicker from './TagInputPicker';

/**
 * Searchable Area of Expertise picker — matches name and keyword aliases from the master catalog.
 */
export default function ExpertiseAreasPicker({
  selected = [],
  onChange,
  catalog = [],
  onCreateItem,
  error,
  hint = '',
  allowRemove = true,
  showCountBadge = true,
  menuZIndex
}) {
  const catalogNames = useMemo(
    () => catalog.map(e => (typeof e === 'string' ? e : e?.name)).filter(Boolean),
    [catalog]
  );

  const searchHaystackForItem = useMemo(() => {
    const byName = new Map(
      catalog
        .filter(e => e && typeof e === 'object')
        .map(e => [String(e.name || '').toLowerCase(), e])
    );
    return name => {
      const entry = byName.get(String(name || '').toLowerCase());
      if (!entry) return name;
      return [entry.name, ...(entry.keywords || [])].join(' ');
    };
  }, [catalog]);

  return (
    <TagInputPicker
      variant="expertise"
      selected={selected}
      onChange={onChange}
      catalog={catalogNames}
      onCreateItem={onCreateItem}
      error={error}
      hint={hint}
      allowRemove={allowRemove}
      showCountBadge={showCountBadge}
      label="area of expertise *"
      placeholder="Type keyword — HR, IT, sales, data science…"
      menuZIndex={menuZIndex}
      searchHaystackForItem={searchHaystackForItem}
      normalizeItem={item => String(item || '').trim()}
    />
  );
}
